export default defineI18nConfig(() => ({
  legacy: false,
  locale: 'fr',
  messages: {
    fr: {
      connexion: {
        dejaInscrit: 'Déjà inscrit ?',
        rememberMe: 'Se souvenir de moi',
        login: 'Se connecter',
        createAccount: 'Créer un compte',
        newUser: 'Nouveau sur Copilot ?',
      },
      labels: {
        email: 'Email',
        password: 'Mot de passe',
        confirmPassword: 'Confirmer le mot de passe',
        ancienPassword: 'Ancien mot de passe',
        nouveauPassword: 'Nouveau mot de passe',
        immatriculation: 'Immatriculation',
        numContrat: 'Numéro de contrat',
        selectionPrestation: 'Sélectionner une prestation',
      },
      denominations: {
        immatriculation: 'Immatriculation',
        energie: 'Énergie',
        dateMec: 'Date MEC',
        // LLD : Location Longue Durée
        dateFinContrat: 'Date fin de contrat LLD',
        dateFinLld: 'Date fin de LLD',
        dateDernierControle: 'Dernier contrôle technique',
        dateDerniereRevision: 'Dernière révision',
        proprietaire: 'Propriétaire',
        critair: "Crit'Air",
        critairNonEligible: 'Non éligible',
        ptac: 'PTAC',
        dernierReleve: 'Dernier relevé',
        documentsVehicule: 'Les documents du véhicule',
        transmettreDocument: 'Transmettre un document',
        aucunDocumentDisponible: 'Aucun document disponible',
        prochainesVisites: 'Prochaines visites',
        prochaineVisite: 'Prochaine visite',
        plusieursVisitesEnRetard: 'Vous avez plusieurs visites en retard',
        rechercheGarageNonAboutie: "Si la recherche n'aboutit pas ou si vous ne trouvez pas le garage,",
        cliquezIci: 'Cliquez ici',
        renseignerInfosGarage: 'Renseignez les informations du garage :',
        deposerVehicule: 'Je dépose mon véhicule',
        recupererVehicule: 'Je récupère mon véhicule',
        livretConducteur: 'Mon Livret conducteur',
        carteAccreditiveFatec: 'Ma carte accréditive',
        nomFichierCarteAccreditive: 'CARTE_ACCRÉDITIVE',
        stepperDepotVehicule: {
          depotVehicule: 'Vous venez de déposer votre véhicule dans un garage ?',
          selectionPrestations: 'Pour quelle(s) prestation(s) ?',
          entrerAdresse: 'Trouver votre garage :',
          rechercherGarage: 'Préciser le garage',
          validerDepot: 'Valider le dépôt',
        },
        formRecupererVehicule: {
          questionRecupererVehicule: "Le véhicule a été déposé le {date} et vous l'avez récupéré le :",
          voirDetailsDepot: 'Voir les détails du dépôt',
          prestationsRealisees: 'Les prestations réalisées sont :',
          recupererLeVehicule: 'Valider',
        },
        valider: 'Valider',
        annuler: 'Annuler',
        precedent: 'Précédent',
      },
      routes: {
        '/vehicules': 'Vos véhicules',
        '/tutoriel': 'Bienvenue !',
        '/releve-kilometrique': 'Relevé kilométrique',
        '/prochaines-visites': 'Prochaines visites',
        '/que-faire/commentaire/revision': 'Revision',
        '/que-faire/commentaire/pneumatiques': 'Pneus',
        '/que-faire/commentaire/reparation': 'Réparation',
        '/que-faire/commentaire/carrosserie': 'Carrosserie',
        '/que-faire/commentaire/controlesTechniques': 'Contrôles techniques',
        '/que-faire/commentaire/sinistre': 'Sinistre',
        '/que-faire/commentaire/brisGlace': 'Bris de glace',
        '/que-faire/commentaire/depannageRemorquage': 'Depannage / Remorquage',
        '/que-faire/commentaire/vehiculeRemplacement': 'Véhicule de remplacement',
        '/que-faire/commentaire/carteCarburantTelebadge': 'Carte carburant / Télébadge',
        '/documents': 'Les documents du véhicule',
        '/documents/transmettre-document': 'Transmettre un document',
        '/mon-compte': 'Mon compte',
        '/notifications': 'Notifications',
        '/immobilisation-vehicule': 'Immobilisation du véhicule',
        '/livret': 'Livret conducteur',
        '/carte-accreditive': 'Ma carte accréditive',
        '/rendez-vous': 'Mes rendez vous',
      },
      releve: {
        addReleve: 'Ajouter un relevé',
        source: {
          copilot: 'Copilot',
          mobipilot: 'Mobipilot',
          garage: 'Garage',
          kuantic: 'Boitier télématique',
          sofleet: 'Boitier télématique',
          petrolier: 'Pétrolier',
          client: 'Client',
        },
      },
      visites: {
        motifs: {
          'CONTROLE TECHNIQUE': 'Contrôle technique',
          'CONTROLE TECHNIQUE PL': 'Contrôle technique PL',
          REVISION: 'Révision',
          'VISITE TECHNIQUE COMPLEMENTAIRE': 'Visite technique complémentaire',
          'CONTROLE TACHYGRAPHE': 'Contrôle tachygraphe',
          'CONTROLE LIMITEUR DE VITESSE': 'Contrôle limiteur de vitesse',
          'CONTROLE ETHYLOTEST': 'Contrôle éthylotest',
          'CONTRÔLE COMPACTION': 'Contrôle compaction',
          'CONTRÔLE LEVAGE': 'Contrôle levage',
        },
        sections: {
          reglementaires: 'Contrôles réglementaires',
          revisions: 'Révisions',
        },
        alertes: {
          reglementaires: {
            error:
              "Un ou plusieurs contrôles réglementaires sont échus. Ce véhicule ne doit plus être utilisé tant qu'il n'est pas en règle.",
            warning:
              "Des contrôles réglementaires arrivent à échéance d'ici 2 mois. Prenez rendez-vous dès que possible.",
          },
          revisions: {
            error: 'Une ou plusieurs révisions sont en retard. Contactez votre atelier dès que possible.',
            warning: 'Une révision arrive prochainement à échéance. Planifiez votre entretien.',
          },
        },
        badge: {
          retard: 'En retard',
          aEcheance: 'À échéance',
          enRetard: 'EN RETARD',
          aPrevoir: 'À PRÉVOIR',
          aJour: 'À JOUR',
        },
        prochaine: 'Prochaine visite :',
        prochaineDate: 'Prochaine date :',
        ou: 'ou',
        retardJours: 'En retard de {count} jour | En retard de {count} jours',
        aVenirJours: 'Dans {count} jour | Dans {count} jours',
        retardKm: 'En retard de {count} km',
        aVenirKm: 'Dans {count} km',
      },
      rdv: {
        statuts: {
          initie: 'Initié',
          traite: 'Traité',
          enAttente: 'En attente',
          valide: 'Validé',
          annule: 'Annulé',
          modifie: 'Modifié',
          finalisation: 'Finalisation',
        },
        dates: {
          prevuLe: 'Prévu le {date} à {heure}',
          reprogrammeLe: 'Reprogrammé le {date} à {heure}',
          enAttente: 'Date de rendez-vous en attente',
        },
        actions: {
          appeler: 'Appeler',
          yAller: 'Y aller',
        },
        messages: {
          aucunRdv: "Vous n'avez aucun rendez-vous planifié pour le moment.",
        },
      },
      notification: {
        titre: {
          alerte: 'Alerte',
          information: 'Information',
          rendezVous: 'Mise à jour RDV',
        },
        filtres: {
          toutes: 'Toutes',
          nonLues: 'Non lues',
          prioritaires: 'Prioritaires',
          archivees: 'Archivées',
        },
        actions: {
          marquerLu: 'Marquer comme lu',
          archiver: 'Archiver',
          desarchiver: 'Désarchiver',
        },
        rdv: {
          statut: {
            valide: 'validé',
            modifie: 'modifié',
            annule: 'annulé',
            defaut: 'mis à jour',
            en_attente: 'en attente',
          },
          chip: {
            valide: 'Validé',
            modifie: 'Modifié',
            annule: 'Annulé',
            enAttente: 'En attente',
          },
          corps: 'Rendez-vous chez {nomFournisseur} {statut}',
          corpsAvecDate: 'Rendez-vous chez {nomFournisseur} {statut} — prévu le {datePrevue}',
        },
        alerte: {
          corps: 'Attention vous devez réaliser votre contrôle au plus vite !',
          depassee: "La date d'échéance a été dépassée !",
          approche: "La date d'échéance approche !",
        },
      },
      recherche: {
        titre: 'RECHERCHER UN GARAGE AGRÉÉ',
        localisation: 'Indiquez votre localisation',
        modifierRecherche: 'Modifier ma recherche',
        filtres: 'Filtres',
        typeService: 'Quel type de service recherchez-vous ?',
        lancerRecherche: 'Lancer la recherche',
        prestation: {
          CONTROLE_TECHNIQUE: 'Contrôle technique',
          PNEUMATIQUE: 'Pneus',
          REVISION: 'Révision, Entretien',
          REPARATION: 'Réparation Mécanique',
          CARROSSERIE: 'Carrosserie',
          VITRAGE: 'Vitrage',
        },
        aucunePrestation: {
          titre: 'Aucune prestation disponible',
          description: "Le service de recherche de garage n'est pas disponible pour votre véhicule actuellement.",
          contact: 'Contactez votre gestionnaire de flotte FATEC',
        },
      },
      queFaire: {
        prestation: {
          entretien: 'Entretien',
          revision: 'Revision',
          pneumatiques: 'Pneus',
          reparation: 'Réparation',
          carrosserie: 'Carrosserie',
          controlesTechniques: 'Contrôles techniques',
          sinistre: 'Sinistre',
          brisGlace: 'Bris de glace',
          depannageRemorquage: 'Depannage / Remorquage',
          vehiculeRemplacement: 'Véhicule de remplacement',
          carteCarburantTelebadge: 'Carte carburant / Télébadge',
        },
      },
      documents: {
        CARTE_GRISE: 'Carte grise',
        MEMO_VEHICULE_ASSURE: 'Memo véhicule assuré',
        CARTE_ACCREDITIVE: 'Carte accréditive',
        PV_CONTROLE_TECHNIQUE: 'Contrôle technique',
        PV_LIVRAISON: 'PV de livraison',
        PV_RESTITUTION: 'PV de restitution',
        CERTIFICAT_CARROSSAGE: 'Certificat carrossage',
        CERTIFICAT_CONFORMITE: 'Certificat conformité',
        CONSTAT_AMIABLE: 'Constat amiable',
        ETAT_DES_LIEUX: 'État de lieux',
        PHOTOS_VHC: 'Photos véhicule',
        PV_CONTRE_VISITE: 'PV contre-visite',
        PV_CONTROLE_POLLUTION: 'PV contrôle pollution',
        RAPPORT_EXPERTISE: 'Rapport expertise',
        RAPPORT_VGP: 'Rapport VGP',
        AUTRE: 'Autre',
      },
      pdfViewer: {
        chargement: 'Chargement du document…',
        erreurChargement: 'Impossible de charger le document.',
        ouvrirNavigateur: 'Ouvrir dans le navigateur',
        pleinEcran: 'Plein écran',
        quitterPleinEcran: 'Quitter le plein écran',
        telecharger: 'Télécharger',
        hautDePage: 'Haut de page',
        partager: 'Partager',
      },
      messageErreur: {
        erreurGenerique: "Une erreur s'est produite, veuillez réessayer plus tard",
        mdpModifie: 'Votre mot de passe à bien été modifié',
        formulaireInvalide: 'Le formulaire est invalide',
        photosManquantes: 'Veuillez prendre les 5 photos demandées',
        captchaInvalide: 'Le captcha est invalide',
        erreurAuth: "Une erreur est survenue lors de l'authentification",
        invalidCredentials: "L'email ou le mot de passe est invalide",
        erreurRegistration: 'Une erreur est survenue lors de la création de votre compte',
        immatAttendue: 'Une immatriculation est attendue',
        immatNonTrouve: "L'immatriculation n'est pas gérée par FATEC, veuillez contacter votre gestionnaire",
        erreurTelechargementDoc: "Une erreur s'est produite lors du téléchargement du document",
        erreurRecupCarteAccreditive: 'Impossible de récupérer la carte accréditive.',
        erreurEnvoiDoc: "Une erreur s'est produite lors de l'envoi du document",
        erreurRecupFournisseurFavori: "Une erreur s'est produite lors de la récupération du fournisseur favori",
        erreurRecupFournisseurs: "Une erreur s'est produite lors de la récupération des fournisseurs",
        erreurAucunFournisseur: "Aucun fournisseur n'a été trouvé",
        erreurAjoutFournisseurFavori: "Une erreur s'est produite lors de l'ajout du fournisseur favori",
        erreurNotationFournisseur: "Une erreur s'est produite lors de la notation du fournisseur",
        erreurRecupUtilisateur: "Une erreur s'est produite lors de la récupération de l'utilisateur",
        erreurRecupVehicules: "Une erreur s'est produite lors de la récupération des véhicules",
        erreurRecupInfosVehicule: 'Erreur lors de la récupération des informations du véhicule',
        erreurAjoutVehicule: "Une erreur s'est produite, vérifiez les informations saisies ou réessayez plus tard",
        erreurAjoutReleveKilometrique: "Erreur lors de l'ajout du relevé kilométrique",
        erreurAjoutEtatDesLieux: "Erreur lors de l'ajout de l'état des lieux",
        erreurInconnu: 'Inconnu',
        erreurDesabonnementNotifications: 'Erreur lors du désabonnement des notifications',
        erreurAbonnementNotifications: "Erreur lors de l'abonnement aux notifications",
        erreurDepotVehicule: 'Erreur lors du dépôt du véhicule',
        erreurRecupVehicule: 'Erreur lors de la récupération du véhicule',
        erreurCreationRendezVous: "Une erreur s'est produite lors de la création du rendez-vous",
        erreurRecupRendezVous: "Une erreur s'est produite lors de la récupération des rendez-vous",
      },
      messageWarning: {
        releveInferieur: 'Le relevé kilométrique est inférieur au dernier relevé, confirmez-vous cette saisie ?',
      },
      messageSucces: {
        mdpModifie: 'Votre mot de passe à bien été modifié',
        compteCree: 'Votre compte à bien été créé',
        vehiculeAjoute: 'Le véhicule a été ajouté avec succès',
        documentEnvoye: 'Le document a été envoyé avec succès',
        fournisseurAjoute: 'Le fournisseur a été ajouté à vos favoris avec succès',
        fournisseurSupprime: 'Le fournisseur a été retiré de vos favoris avec succès',
        fournisseurNote: 'Le fournisseur a été noté avec succès',
        vehiculeSupprime: 'Le véhicule a été supprimé avec succès',
        majReleveKilometrique: 'Votre relevé kilométrique à bien été mis a jour',
        etatDesLieuxEnvoye: "L'état des lieux a été transmit avec succès",
        depotVehicule: 'Votre véhicule a bien été déposé',
        recupVehicule: 'Votre véhicule a bien été récupéré',
      },
      validation: {
        emailManquant: "L'email est obligatoire",
        emailInvalide: "L'email est invalide",
        passwordManquant: 'Le mot de passe est obligatoire',
        confirmerPassword: 'Confirmer le mot de passe',
        passwordIdentique: 'Les mots de passe doivent être identiques',
        ancienPasswordManquant: "L'ancien mot de passe est manquant",
        conditionsUtilisation: "Vous devez accepter les conditions d'utilisation",
        immatriculationManquante: "L'immatriculation est obligatoire",
        numDossierManquant: 'Le numéro de dossier est obligatoire',
        releveInvalide: 'Le relevé kilométrique est invalide',
        releveManquant: 'Le relevé kilométrique est manquant',
        releveNombre: 'Le relevé kilométrique doit être un nombre',
        typeDocumentObligatoire: 'Le type de document est obligatoire',
        typeDocumentPrecision: 'Veuillez préciser le type de document',
        notationGarage: 'Veuillez noter le garage',
        expliquerNotation: 'Veuillez expliquer votre mécontentement',
        commentaireMax: 'Le commentaire ne doit pas dépasser 1500 caractères',
        numeroTelValide: 'Veuillez entrer un numéro de téléphone valide',
        requis: 'Champ requis',
      },
    },
  },
}));
